import { ToggleSwitchInput } from "elements";
import React, { useState, useEffect } from "react";
import { useTranslation } from "utilities/i18n";
import {
  useRequestToggleFlashMutation,
  useGetFlashStatusQuery
} from "generated/graphql";
import { DISMISS, useNotification } from "collections";

export const LogToFlash: React.FC<{ deviceId: string }> = ({ deviceId }) => {
  const { t } = useTranslation();
  const [addNotification] = useNotification();
  const [flashToggleEnabled, setFlashToggleEnabled] = useState(false);
  const [, requestToggleFlash] = useRequestToggleFlashMutation();
  const { data } = useGetFlashStatusQuery({
    variables: {
      deviceId
    }
  });
  const valueFromFetch = data?.logToFlashStatus.requestedValue ?? false;

  useEffect(() => {
    setFlashToggleEnabled(valueFromFetch);
  }, [valueFromFetch]);

  async function handleFlashToggle(value: boolean) {
    const response = await requestToggleFlash({
      deviceId,
      enableFlash: value
    });
    if (response.error || response.data?.toggleLogToFlash.error) {
      // throw a toast notification and exit the function
      addNotification({
        id: "log-to-flash-failed",
        type: "error",
        message: t("LOG_TO_FLASH_ERROR"),
        dismiss: DISMISS.DEFAULT
      });
      return;
    }
    // If the response comes back with data, update the state
    const requestedValue = !!response.data?.toggleLogToFlash.requestedValue;
    setFlashToggleEnabled(requestedValue);
  }

  const logToFlashMessageClasses =
    "col-9 offset-3 mb-0 italic opacity-50 flash-message";

  return (
    <>
      <div className="form-group" data-testid="flash-logs">
        <label className="col-3 text-right">{t("SAVE_LOGS_TO_INTERNAL")}</label>
        <div className="col-2">
          <ToggleSwitchInput
            name="flashLogsToggle"
            data-testid="flashLogsToggle"
            checked={flashToggleEnabled}
            disabled={false}
            onChange={() => handleFlashToggle(!flashToggleEnabled)}
          />
        </div>
      </div>
      <div className="form-group">
        <p className={logToFlashMessageClasses}>
          {t("FLASH_LOGS_MESSAGE_LINE_1")}
        </p>
        <p className={logToFlashMessageClasses}>
          {t("FLASH_LOGS_MESSAGE_LINE_2")}
        </p>
      </div>
    </>
  );
};
